import { createFetchActionCreator } from './index';
import { API_OFFERING_WATCHES } from './urls';

export const OFFERING_WATCHES = 'OFFERING_WATCHES';

export const getOfferWatches = () => async (dispatch, getState) => {
  const state = getState();
  const { id } = state.user.data;
  const fn = createFetchActionCreator(`${API_OFFERING_WATCHES}?userId=${id}`, 'offeringWatches', {}, {
    requireAuth: true,
  })();
  return fn(dispatch, getState);
};

export default {};



// WEBPACK FOOTER //
// ./src/actions/offerWatches.js